import { useTranslation } from "react-i18next";
import { Languages, Check } from "lucide-react";
import { Button } from "./ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { setLanguage, normalizeLang, ENABLED_LOCALES } from "../i18n";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";

export const LanguageSelector = () => {
  const { t, i18n } = useTranslation("common");
  const { user, setUser } = useAuth();
  const current = normalizeLang(i18n.language);

  const choose = async (lng) => {
    const l = setLanguage(lng);              // UI immédiate + localStorage
    if (user) {
      try {
        const { data } = await api.patch("/account/profile", { locale: l });
        if (data?.user) setUser(data.user);  // persiste user.locale côté serveur
      } catch (e) { /* non bloquant */ }
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          data-testid="language-selector-btn"
          variant="outline"
          size="sm"
          className="border-slate-200 bg-white hover:bg-slate-100 text-slate-900 uppercase"
          aria-label={t("lang.label")}
        >
          <Languages className="w-4 h-4 mr-1.5 text-emerald-600" />
          {current}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" data-testid="language-selector-menu">
        {ENABLED_LOCALES.map(({ code: lng, nativeLabel }) => (
          <DropdownMenuItem
            key={lng}
            data-testid={`language-option-${lng}`}
            onClick={() => choose(lng)}
            className="cursor-pointer flex items-center justify-between gap-6"
          >
            <span lang={lng}>{nativeLabel}</span>
            {current === lng && <Check className="w-4 h-4 text-emerald-600" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
